import ServiceCall from '../components/ServiceCall.vue'
import AutoLogin from '../components/AutoLogin.vue'
import Order from '../components/Order.vue'
import Dashboard from '../components/Dashboard.vue'
import Profile from '../components/Profile.vue'
import MeterReadings from '../components/MeterReadings.vue'
import SignOut from '../components/SignOut.vue'
import Clients from '../components/Clients.vue'
import AdminManagement from '../components/AdminManagement.vue'
import ClientsDetail from '../components/ClientsDetail.vue'
import ClientsDevice from '../components/ClientsDevice.vue'
import ManagerUser from '../components/ManagerUser.vue'
import ClientsUser from '../components/ClientsUser.vue'
import UserDetail from '../components/UserDetail.vue'
import AdminDetail from '../components/AdminDetail.vue'
import SignIn from '../components/SignIn.vue'
import RequestAccess from '../components/RequestAccess.vue'
import Contact from '../components/Contact.vue'
import ForgotPassword from '../components/ForgotPassword.vue';
import ForgotPasswordConfirm from '../components/ForgotPasswordConfirm.vue';
import FindMachineID from '../components/FindMachineID.vue';
import FindSerial from '../components/FindSerial.vue';
import NotFound from '../components/errors/NotFound.vue'
import NotAllowed from '../components/errors/NotAllowed.vue'

function authConfig(scope = 'user') {
    if (scope) {
        return {
            meta: { auth: scope }
        }
    }

    return {
        meta: { auth: false }
    }
}

export default [
    //all user

    { path: '/sign-out', component: SignOut, name: 'signOut', ...authConfig(['user', 'manager', 'group-admin', 'admin', 'super-admin']) },
    { path: '/profile', component: Profile, name: 'profile', ...authConfig(['user', 'manager', 'group-admin', 'admin', 'super-admin']) },
    { path: '/contact', component: Contact, name: 'contact', ...authConfig(false) },

    //admin only
    { path: '/client', component: Clients, name: 'adminClients', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/add', component: ClientsDetail, name: 'adminClientsAdd', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/edit/:clientID', component: ClientsDetail, name: 'adminClientsEdit', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/user', component: ClientsUser, name: 'adminUser', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/user/add', component: UserDetail, name: 'adminUserAdd', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/user/edit/:userID', component: UserDetail, name: 'adminUserEdit', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/device', component: ClientsDevice, name: 'adminDevice', ...authConfig(['admin', 'super-admin']) },

    { path: '/client/:clientID/book-service-call', component: ServiceCall, name: 'adminBookServiceCall', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/order-consumables', component: Order, name: 'adminOrderConsumables', ...authConfig(['admin', 'super-admin']) },
    { path: '/client/:clientID/meter-readings', component: MeterReadings, name: 'adminMeterReadings', ...authConfig(['admin', 'super-admin']) },


    { path: '/staff', component: AdminManagement, name: 'staffManagement', ...authConfig(['super-admin']) },
    { path: '/staff/add', component: AdminDetail, name: 'staffManagementAdd', ...authConfig(['super-admin']) },
    { path: '/staff/edit/:userID', component: AdminDetail, name: 'staffManagementEdit', ...authConfig(['super-admin']) },


    //manager
    { path: '/user', component: ManagerUser, name: 'managerUser', ...authConfig(['manager']) },
    { path: '/user/add', component: UserDetail, name: 'managerUserAdd', ...authConfig(['manager']) },
    { path: '/user/edit/:userID', component: UserDetail, name: 'managerUserEdit', ...authConfig(['manager']) },


    //group admin
    { path: '/admin', component: Clients, name: 'groupAdminClients', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/device', component: ClientsDevice, name: 'groupAdminDevice', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/user', component: ClientsUser, name: 'groupAdminUser', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/user/add', component: UserDetail, name: 'groupAdminUserAdd', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/user/edit/:userID', component: UserDetail, name: 'groupAdminUserEdit', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/book-service-call', component: ServiceCall, name: 'groupAdminBookServiceCall', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/order-consumables', component: Order, name: 'groupAdminOrderConsumables', ...authConfig(['group-admin']) },
    { path: '/admin/:clientID/meter-readings', component: MeterReadings, name: 'groupAdminMeterReadings', ...authConfig(['group-admin']) },

    //user and manager
    { path: '/dashboard', component: Dashboard, name: 'dashboard', ...authConfig(['user', 'manager']) },
    { path: '/', redirect: { name: 'signIn' }, name: 'home', ...authConfig(['user', 'manager']) },

    //every body
    { path: '/book-service-call', component: ServiceCall, name: 'bookServiceCall', ...authConfig(false) },
    { path: '/order-consumables', component: Order, name: 'orderConsumables', ...authConfig(false) },
    { path: '/meter-readings', component: MeterReadings, name: 'meterReadings', ...authConfig(false) },


    { path: '/sign-in', component: SignIn, name: 'signIn', ...authConfig(false) },
    { path: '/request-access', component: RequestAccess, name: 'requestAccess', ...authConfig(false) },

    { path: '/forgot-password', component: ForgotPassword, name: 'forgotPassword', ...authConfig(false) },
    { path: '/reset-password/:secretToken', component: ForgotPasswordConfirm, name: 'forgotPasswordConfirm', ...authConfig(false) },

    { path: '/find-machine-id/', component: FindMachineID, name: 'findMachineID', ...authConfig(false) },
    { path: '/find-serial/', component: FindSerial, name: 'findSerial', ...authConfig(false) },


    { path: '/autologin', component: AutoLogin, name: 'autologin', ...authConfig(false) },

    { path: '/403', component: NotAllowed, name: '403', ...authConfig(false) },
    { path: '/:catchAll(.*)', component: NotFound, name: '404', ...authConfig(false) },
]
